import Header from './Header';
import ImageCarousel from './Slide';
import Section from './Section';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';

const Homepage = () => {
  return ( 
    <div className="w-full min-h-screen overflow-x-hidden bg-slate-50">
      <Header />
      <ImageCarousel />
      <Section />
      <Footer />
      <ScrollToTop />
    </div>
  );
}
 
export default Homepage;